import React from 'react';
import { FaultsChartContainer } from '../charts';
import ChartTab from './ChartTab';

interface FaultsTabProps {
  machineSerialNo?: string;
  lineId?: string; // Line ID for line-level aggregated data
  shifts?: string[];
  syncGroup?: string;
  activeSubTab?: 'number' | 'duration' | 'status';
  onActiveSubTabChange?: (tab: 'number' | 'duration' | 'status') => void;
  aggType?: 'number' | 'percent';
  onAggTypeChange?: (type: 'number' | 'percent') => void;
}

const FaultsTab: React.FC<FaultsTabProps> = ({ 
  machineSerialNo, 
  lineId,
  shifts, 
  syncGroup,
  activeSubTab,
  onActiveSubTabChange,
  aggType,
  onAggTypeChange
}) => {
  // Suppress unused syncGroup warning
  React.useEffect(() => { void syncGroup; }, [syncGroup]);

  return (
    <ChartTab>
      <FaultsChartContainer 
        machineSerialNo={machineSerialNo}
        lineId={lineId}
        shifts={shifts}
        activeSubTab={activeSubTab}
        onActiveSubTabChange={onActiveSubTabChange}
        aggType={aggType}
        onAggTypeChange={onAggTypeChange}
      />
    </ChartTab>
  );
};

export default FaultsTab;
